import React, { useState, useEffect } from 'react';
import StarRating from './common/StarRating';
import SkillsStarRating from './common/SkillsStarRating';
import MinusIconRed from './../images/minus-red.svg';
import SearchIcon from './../images/search.svg';
import { EDUCATION_LINK, FINALIZE_LINK, FINAL_RESUME, WORKHISTORY_LINK, HEADING_LINK, NEXT_FINALIZE_LABEL, NEXT_LABEL, NEXT_SKILLS_LABEL, NEXT_SUMMARY_LABEL, SKILLS_LINK, SUMMARY_LINK, SKILL_LEVEL, ADDITIONAL_SECTIONS_LINK, SKIP_CONFIRMATION_BOX_CONTENT, DELETE_CONFIRMATION_BOX_CONTENT, POPUP_TYPES, EDITOR_ALL_INONE_LINK, SKILL_TIPS_LINK, DISABLED_RATING_TEMPLATES } from '../constants/constants';
import ErrorValidator from '../ErrorValidator';
import { Redirect } from 'react-router';
import QuickTips from './common/QuickTips';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import WpAPI from '../WpApi';
import { useResume } from '../context/ResumeContext';
import { usePopup } from '../context/PopupContext';
import { setBodyHeight } from '../helper';
//import { removeBodyScroll } from '../helper';

const EditorSkills = (props) => {

  const {
    resume: {
        heading: { fname },//Used to intentify component is ignored with first call with initial-data, and react with second time component is called with user input data
        skills,
        enabled_tabs,
        skipped_sections,
        active_template
    },
    handlers: {
        updateResumePreview,
        nuteralizeNextClick,
        nuteralizeBackClick
    },
    next_clicked,
    next_label,
    back_clicked,
    skip_clicked,
    toggleSkip
} = useResume();
const confirmbox = usePopup();
  const skillset = skills.set
  const rating_disabled = skills.hasOwnProperty('rating_disabled') ? skills.rating_disabled : true
  const errorStyle = { color: 'red', fontSize: '10px', paddingTop: '7px', paddingLeft: '32px' }
  const validatorSet = {
    name: { empty: "Please enter skill" },
    rating: {
      other1: {
        msg: "Please select rating star",
        validator: val => (!rating_disabled && val == 0)
      }
    },
    // start_date: { empty: "Please Enter Start Date" },
  };
  //For error validations
  const validators = {}
  // const dispatch = useDispatch();
  const [error, setError] = useState({})
  const emptyskill = {
    rating: 0,
    name: "",
  }
  const [showToolTip, setShowToolTip] = useState(false);
  //Flag is Do Next redirect
  const [redirectNext, setredirectNext] = useState(false)

  //Flag is Do Back redirect
  const [redirectBack, setredirectBack] = useState(false)
  //Component asked to redirect, first validate
  const [callOnce, setcallOnce] = useState(false)
  //Set Expert recommendated List
  const [skillRecommendedPoints, setSkillRecommendedPoints] = useState([]);
  const [searchMe, setSearchMe] = useState('');
  const type = 'skill';
  const [openedId, setOpenedId] = useState();
  const [skipSection, setSkipSection ] = useState(false)
  const [showNameInput, setShowNameInput] = useState(false)
  const[editName, setEditName] = useState(false)
  const[checkField, setCheckField] = useState(false)
  
  //Quick edit mode
  const QEM = enabled_tabs.includes('completed')
  const label = (l) => QEM ? NEXT_LABEL : l
  const rURL = (u) => QEM ? FINAL_RESUME : u
  const skipped = skipped_sections?.includes('skills')
  const nextClicked = () => {
    
    if(skip_clicked){
      return toggleSkip('skills')
    } else if (next_clicked ) {//Set for next page
      const blk = checkBlankSection()
            if(blk && !skipped) {
                confirmbox.show('section_skip',null,() => {
                    toggleSkip('skills');
                    setredirectNext(true)
                })
                nuteralizeNextClick({ next_label: label(NEXT_LABEL)  })
                return false
            }else{
      nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped?'Add':'Skip'  }, true, 'additional_sections')
      return true
      }
    } else {//Set for own page
     // if (next_clicked || next_label != label(NEXT_SUMMARY_LABEL)) {
        //Always run for next click and self label not matched
        nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped?'Add':'Skip'  })
        return false
      //}
    }
  }
  const backClicked = () => {
    if (back_clicked) {
      nuteralizeBackClick({ next_label: label(NEXT_LABEL) })
      return true
    }
  }
  const checkBlankSection = () => {
    let ids = Object.keys(skillset)
    let secblank = null
    if (ids.length == 1) {
        ids.forEach(ele => {
            const skill = skillset[ele]
            secblank = !( skill.name.trim().length )
        })
    }
    return secblank;
}

  const errorExists = () => {
    let anyerror = [];
    Object.keys(error).map((key) => {
      if (error[key] != '')
        anyerror.push(key);
    });
    return anyerror.length > 0 ? true : false;
  }

  const validateForm = () => {
    // if (!errorExists()) {
    if (1) {//validate on each hit
      let v = {}
      //validate for each skills, store validate in object
      Object.keys(skillset).map(key => {
        if (!validators.hasOwnProperty(key)) validators[key] = new ErrorValidator(validatorSet)
        const er = validators[key].validateFields(skillset[key])
        if (Object.keys(er).length) v[key] = er
      })
      // let v = validateFields();
      if (Object.keys(v).length == 0) {
        return true;
      } else {
        //No need to merge
        setError({ ...v });
        return false;
      }
    } else {
      return false;
    }
  }
  const removeError = (field, id) => {
    if (error.hasOwnProperty(id) && error[id].hasOwnProperty(field)) {
      //remove for whole set, has two use cases
      let e = { ...error }
      if (Object.keys(e[id]).length == 1) delete e[id]
      else delete e[id][field]
      setError({ ...e })
    }
  }

  const fieldFocus = (field, id) => {
    setCheckField(field);
    removeError(field, id);
    updateSkill({ validated: { ...skillset.validated, [field]: false } }, id)
  }

  const fieldBlur = (field, value, id) => {
    setCheckField(false);
    // const er = validateFields(e.target.name)
    if (!validators.hasOwnProperty(field)) validators[field] = new ErrorValidator(validatorSet)
    const er = validators[field].validateFields(value, field)
    if (!Object.keys(er).length) {//Error not found
      updateSkill({ validated: { ...skillset.validated, [field]: true } }, id)
      removeError(field, id)
    } else {//two use cases
      if (error.hasOwnProperty(id)) {
        let e = { ...error }
        setError({ ...error, [id]: { ...error[id], ...er } })

      } else setError({ ...error, [id]: { ...er } })
    }
  }
  const hasError = (field, id) => (
    error.hasOwnProperty(id) &&
    error[id].hasOwnProperty(field) &&
    error[id][field].length
  )
  const getSkillsArr = () => {
    let skillArr = [];
    Object.keys(skillset).map((index) => {
      skillArr.push({ 'id': index, 'name': skillset[index].name });
    });
    return skillArr;
  }

  useEffect(() => {
    if (nextClicked()) setredirectNext(true)
    else setredirectNext(false)
    if (backClicked()) setredirectBack(true)
    else setredirectBack(false)

    setcallOnce(false)
  }, [callOnce, fname]);
  useEffect(() => {
    setSkipSection(skipped_sections?.includes('skills'))
}, [skipSection, skipped_sections]);
useEffect(() => {
  confirmbox.configurePopup(POPUP_TYPES);

  //if template in the constent DISABLED_RATING_TEMPLATES set rating_disabled true;
  if(DISABLED_RATING_TEMPLATES.indexOf(active_template) != -1){
    updateRatingDisability({ rating_disabled: true })
  }
}, []);

  const updateSkill = (input, id) => {
    const skill = {
      [id]: {//example skill_1
        ...skillset[id],
        ...input
      }
    }
    updateResumePreview(
      { skills: { ...skills, set: { ...skillset, ...skill }, rating_disabled: rating_disabled }, current_tab: 'skills', }
    )
  }
  const updateRatingDisability = (input) => {
    updateResumePreview(
      { skills: { ...skills, set: { ...skillset }, rating_disabled: input.rating_disabled }, current_tab: 'skills',}
    )
  }
  const addSkill = (newname = '') => {
    const id = 'skill_' + Math.floor(Math.random() * 1000)
    const e = { ...emptyskill }
    if (newname.length) e.name = newname
    updateResumePreview(
      { skills: { ...skills, set: { ...skillset, [id]: { ...e } }, rating_disabled: rating_disabled }, current_tab: 'skills',  }
    )
    setOpenedId(id);
  }
  const deleteSkill = (id) => {
    if (Object.keys(skillset).length == 1) {
      setError({ ...error, [id]: { name: 'At least one skill set should be present' } })
    } else if (skillset.hasOwnProperty(id)) {
      let t = { ...skillset }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default settings
        t = { ...emptyskill }
      }
      updateResumePreview({ skills: { ...skills, set: { ...t }, rating_disabled: rating_disabled },current_tab: 'skills' })
    }
  }
  const showTabOpenCloseIcon = () => (
    props.hasOwnProperty('tabOpened') ?
      <span className="open-close-btn light-blue" onClick={() => {
        props.tabClicked('skills', false);
        setShowNameInput(false);
        setBodyHeight();
      }}>
        {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
        </span> : ''
  )
  //Keep the control on multiple rendering and out of limit. Force to update once
  if ((next_clicked || back_clicked) && !callOnce) setcallOnce(true);
  // if (!active_tabs.includes('skills')) return <Redirect to={HEADING_LINK} />
  if (redirectNext) { history.pushState(null, SKILLS_LINK); return <Redirect to={rURL(ADDITIONAL_SECTIONS_LINK)} /> }
  if (redirectBack) return <Redirect to={rURL(EDUCATION_LINK )} />
  return (<>
    <div className="editor-block-inner">
      {props.splash}
      <div className="editor-area light-blue-line">
        <div className="form-heading">
          <div className={`on-off-btn ${skipSection?'disabled':'light-blue' }`} onClick={e => skipped ? toggleSkip('skills') : confirmbox.show('section_skip',null,() => toggleSkip('skills'))}>
            <span><i></i></span>
          </div>
          {props.hasOwnProperty('tabClicked') 
          ? <><div className="heading" onClick={() => {
                if(!showNameInput){
                    props.tabClicked('skills', editName);
                    setEditName(false);
                }
            }}>
                {showNameInput 
                ? '' 
                : <>
                    <h1>
                      {skills.name ?? 'Key Skills'} {
                        props?.tabOpened && props.tabOpened 
                        ? <i className="icon-pencil" onMouseOver={() => setEditName(true)} onClick={() => {
                        setShowNameInput(true);
                        props.tabClicked('skills', editName);
                        }}></i>
                        : ''
                      }
                    </h1>
                </>
            }
            {showNameInput 
                ? <input
                    type="text"
                className="edit-block-name"
                    name="name"
                    value={skills.name ?? 'Key Skills'}
                    onChange={(e) => {
                        props.tabClicked('education', true)
                        updateResumePreview({ skills: {...skills, name: e.target.value }});
                    }}
                    onFocus={(e) => updateResumePreview({ skills: {...skills, name: e.target.value }})}
                    onBlur={(e) => {
                        updateResumePreview({ skills: {...skills, name: e.target.value }})
                        setShowNameInput(false)
                    }}
                />
                : '' 
            }
            <p>Include skills that are most relevant to your field and expertise.</p>
          </div></>
          : <div className="heading" style={{cursor: "default"}}>
              <h1>{skills.name ?? 'Key Skills'}</h1>
              <p>Include skills that are most relevant to your field and expertise.</p>
            </div>
          }
          {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips light-blue">
            <span
              onClick={() => {
                setShowToolTip(!showToolTip);
              }}><i className="icon-lightbulb-on"></i>Quick Tips</span>
            {showToolTip ? <QuickTips section="skills" setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
          </div>}
          {showTabOpenCloseIcon()}
        </div>


        {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <>
        <div className="button-wrap">
          <div className={`on-off-btn${rating_disabled ? ' disabled' : ' light-blue' }`}>
            <p>
              <input
                type="checkbox"
                id="rating_disabled"
                defaultChecked={rating_disabled ? false : true}
                onChange={e => updateRatingDisability({ rating_disabled: !rating_disabled })}
              />
              <span><i></i></span> Show experience level</p>

          </div>
        </div>
          <div className="skills-wrap">
          {Object.keys(skillset).map((id) => {
            let index = (skillset[id].rating - 1);
            return (<div className={`skills-list-wrap open`} key={id}>
            <div className="skills-block">
                {/* <div className="reorder-wrap"><DraggableIcon /></div> */}
                <div className="delete-wrap" onClick={(e) => {deleteSkill(id) }}>
                    <DeleteIcon />
                </div>
            </div>
            <div className="label-field"><label className={`label${checkField == 'name' ? ' label-focus': '' }`}>Skill</label></div>
              <div className={`skill-form${!rating_disabled ? '' : ' block-full'}`}>
                <div className={`skill-field`}>
                 <input
                    type="text"
                    className="form-input skill-input-width"
                    value={skillset[id].name}
                    onChange={(e) => {
                      updateSkill({ name: e.target.value }, id);
                    }}
                    onBlur={(e) => {
                      fieldBlur("name", e.target.value, id);
                    }}
                    onFocus={(e) => {
                      fieldFocus("name", id);
                    }}
                  />
                  {hasError("name", id) && (
                    <span className='error-style'>{error[id].name}</span>
                  )}
                </div>
                {!rating_disabled ? <div className="skill-level">
                  
                <div className="rating-box-wrap">
                  <div className="rating-box">
                      <SkillsStarRating
                        value={skillset[id].rating}
                        updateRating={(r) => {
                          updateSkill({ rating: r }, id);
                          removeError("rating", id);
                        }}
                      />
                      {hasError("rating", id) && (
                        <span className='error-style'>{error[id].rating}</span>
                      )}
                    </div>
                  </div>
                </div> : ''}
              </div>
            </div>
            )
          })}
          </div>
        <div className="add-more-wrap">
            <span
              className="add-more-skills key-skill-blue"
              onClick={(e) => {
                addSkill()
              }}>
              <i className="icon-plus-icon"></i>  Add another skill
            </span>
          </div></>}

      </div>
    </div>
  </>);
}

export default EditorSkills;

